import { request, Response } from '../utils';
import { Session } from '../types';

export const completePasswordReset = (body: {
  username: string;
  passwordResetCode: string;
  newPassword: string;
}): Response<{ session: Session }> => request('complete-password-reset', body);
